import { FormEvent, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export function LoginPage() {
  const { user, enter, loading } = useAuth()
  const nav = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (!loading && user) return <Navigate to="/" replace />

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    const name = String(new FormData(e.currentTarget).get('name') || '').trim()
    if (!name) {
      setError('Type a name')
      setBusy(false)
      return
    }
    try {
      await enter(name)
      nav('/')
    } catch (err: any) {
      const msg = String(err?.message || 'Could not enter')
      if (/Cannot reach API|Failed to fetch|network/i.test(msg)) {
        setError('Server offline — hard refresh or ask the host to start the API')
      } else {
        setError(msg)
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <div className="login-card">
        <div
          className="login-hero"
          style={{ backgroundImage: 'url(/assets/mma/hero-backdrop/wide.png)' }}
        />
        <div className="login-body">
          <h1>Ultimate Sports</h1>
          <p className="muted">Fight night with friends. Type your name and go.</p>
          {error && (
            <div className="error" data-testid="login-error">
              {error}
            </div>
          )}
          <form onSubmit={onSubmit}>
            <div className="field">
              <label>Your name</label>
              <input
                name="name"
                required
                autoFocus
                autoComplete="nickname"
                maxLength={64}
                placeholder="e.g. Mike"
                data-testid="username"
              />
            </div>
            <button
              className="btn"
              disabled={busy}
              type="submit"
              data-testid="auth-submit"
              style={{ width: '100%' }}
            >
              {busy ? '…' : 'Enter'}
            </button>
          </form>
          <p className="muted" style={{ marginTop: 14, fontSize: 12.5 }}>
            New name creates an account with <strong>500 credits</strong>. Same name next time brings
            you back.
          </p>
        </div>
      </div>
    </div>
  )
}
